import Repository from './Repository'

const resource = 'trainings'

export default {
  getTasks (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  }
}
